<template>
    <div class="date-picker-box">
        <div class="ele-date" v-if="$store.state.type == 'pc'">
            <el-date-picker
                ref="number_picker"
                v-model="time"
                type="daterange"
                align="center"
                size="medium"
                :clearable="clearable || false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="timestamp"
                :disabled="disabled || false"
                @change="selectDate"
                :default-time="['00:00:00', '23:59:59']"
                :picker-options="option">
            </el-date-picker>
        </div>
        <div class="van-date" v-else>
            <div class="date_box">
                <p class="satrt" @click="dateShow(1)">{{date[0] ? formDate(date[0], 'YYYY-MM-DD') : '起始时间'}}</p>
                <span class="to">至</span>
                <p class="end"  @click="dateShow(2)">{{date[1] ? formDate(date[1], 'YYYY-MM-DD') : '结束时间'}}</p>
            </div>
            <van-popup v-model="show" position="bottom">
                <van-datetime-picker
                v-model="currentDate"
                :type="vanType ? vanType : 'date'"
                title="选择年月日"
                @confirm="selectDate"
                @cancel="show = false"
                />
            </van-popup>
        </div>
    </div>
</template>
<script>
const moment = require('moment');
export default {
    name: 'datepicker',
    data() {
        return {
            time: '',
            show: false,
            type: 'start',
            currentDate: '',
            option: {
            }
        }
    },
    /*
        date: 日期数据
        disabledToday: 是否可选择今天，默认true
        min: 最少选择天数，默认1天
        max： 最大选择天数
        clearable：是否可清空，默认false
        disabled: 是否禁用,默认false，全屏模式下禁用 
        disabledDate: 是否能选择未来日期，默认false
    */
    props: ['date', 'disabledToday', 'min', 'max', 'clearable', 'disabled', 'disabledDate', 'shortcuts', 'vanType'],
    watch: {
        date: function(nD) {
            this.time = [...nD];
        },
        time: function(nTime, oTime) {
            if(nTime) {
                if(this.min) {
                    if(nTime[1] - nTime[0] < 86400000 * (this.min - 1)) { //小于最小天数
                        this.time = oTime;
                        this.$message.warning(`最少选择${this.min}天！`);
                        return;
                    }
                }
                if(this.max) {
                    if(nTime[1] - nTime[0] > 86400000 * this.max) {  //最长天数限制
                        this.time = oTime;
                        this.$message.warning(`最多可选择${this.max}天！`);
                        return;
                    }
                }
            }
        },
        '$store.state.menuShow': function(nM) {
            if(nM && this.$store.state.type == 'pc') {
                this.$refs.number_picker.pickerVisible = false
            }
        }
    },
    created() {
        this.time = [...this.date];
        this.option.disabledDate = (time) => {
            if(!this.disabledDate) {
                const date = new Date();
                return time.getTime() > (Date.now() + ((24 - date.getHours())  * 3600 - date.getMinutes() * 60 - date.getSeconds() - 1) * 1000  - date.getMilliseconds());
            }
        }
        if(this.disabledToday) {  //禁止选择今天
            this.option.disabledDate = (time) => {
                const date = new Date();
                return time.getTime() > date.getTime() - (date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds() + 1) * 1000 - date.getMilliseconds();
            };
        }
        this.option.shortcuts = this.shortcuts || this.setShortcuts();
        
    },
    methods: {
        setShortcuts() {
            let _this = this;
            let shortcuts = [
                {
                    text: '最近7天',
                    onClick(picker) {
                        picker.$emit('pick', _this.setDate(7,_this.disabledToday));
                    }
                }
            ];
            if(!this.max || this.max >= 30) {
                shortcuts.push({
                    text: '最近30天',
                    onClick(picker) {
                        picker.$emit('pick', _this.setDate(30,_this.disabledToday));
                    }
                })
            }
            if(!this.max || this.max >= 90) {
                shortcuts.push({
                    text: '最近90天',
                    onClick(picker) {
                        picker.$emit('pick', _this.setDate(90,_this.disabledToday));
                    }
                })
            }
            if(!this.disabledToday && !this.min) {
                shortcuts.push({
                    text: '今天',
                    onClick(picker) {
                        let [start, end] = _this.setDate(1);
                        picker.$emit('pick', [start, end]);
                    }
                })
            }
            if(!this.min) {
                shortcuts.push({
                    text: '昨天',
                    onClick(picker) {
                        let [start, end] = _this.setDate(2);
                        picker.$emit('pick', [start, end - 86400000]);
                    }
                })
            }
            shortcuts.push({
                text: '本周',
                onClick(picker) {
                    let week = (new Date()).getDay();
                    week = week == 0 ? 7 : week;
                    picker.$emit('pick', _this.setDate(week));
                }
            },{
                text: '上周',
                onClick(picker) {
                    let week = (new Date()).getDay();
                    week = week == 0 ? 7 : week;
                    let [start, end] = _this.setDate(week + 7);
                    picker.$emit('pick', [start, end - 86400000 * week]);
                }
            },{
                text: '本月',
                onClick(picker) {
                    let day = (new Date()).getDate();
                    picker.$emit('pick', _this.setDate(day));
                }
            },{
                text: '上月',
                onClick(picker) {
                    const now = new Date(); // 当前日期
                    const nowMonth = now.getMonth(); // 当前月(0~11)
                    const nowDay = now.getDate(); // 当前多少号(1~31)
                    const nowYear = now.getFullYear(); // 当前年份
                    let lastTotalDay = '';  //上个月的天数
                    if (nowMonth === 0) {  //当前1月份,上个月跨年
                        // 获取去年12月总共有多少天
                        lastTotalDay = new Date(nowYear - 1, 12, 0).getDate()
                    } else {
                        // 获取上月总共有多少天
                        lastTotalDay = new Date(nowYear, nowMonth, 0).getDate()
                    }
                    let [start, end] = _this.setDate(nowDay + lastTotalDay);
                    picker.$emit('pick', [start, end - 86400000 * nowDay]);
                }
            })
            return shortcuts;
        },
        dateShow(type) {
            if(type == 1) {
                this.currentDate = this.date[0] ? new Date(this.date[0]) : new Date();
            }else{
                this.currentDate = this.date[1] ? new Date(this.date[1]) : new Date();
            }
            this.type = type;
            this.show = true;
        },
        selectDate(date) {
            if(this.$store.state.type == 'pc') {
                this.$emit('dateSelect', date);
            }else{
                const timestamp = moment(date).valueOf();
                this.show = false;
                //将日期格式化为时间戳
                if((this.type == 1 && timestamp > this.date[1]) || (this.type == 2 && timestamp < this.date[0])) {
                    this.$message.warning('结束日期不能小于起始日期！');
                    return;
                }
                if(this.type == 1) {
                    this.date[0] = timestamp;
                }else{
                    this.date[1] = timestamp + 86399000;
                }
                this.$emit('dateSelect', this.date);
            }
        }
    }

}
</script>
<style scoped lang="less">
    .date-picker-box{
        width: 100%;
        /deep/.el-popper[x-placement^=bottom] .popper__arrow{
            border-bottom-color: #EBEEF5!important;
        }
        /deep/.el-popper[x-placement^=bottom] .popper__arrow::after{
            border-bottom-color: #fff!important;
        }
    }
    
    
    .date_box{
        border: 1px solid @colorLine;
        border-radius: 4px;
        line-height: 28px;
        color: @color333;
        font-size: 0.12rem;
        padding: 0 10px;
        width: 100%;
        box-sizing: border-box;
        .flexLayout(space-around);
        flex-wrap: nowrap;
        p{
            width: 50%;
            min-width: 70px;
            text-align: center;
        }
        .to{
            color: @colorGray;
            padding: 0 8px;
        }
    }
    .search-form{
        .datepicker{
            min-width: 200px;
        }
        .date_box{
            line-height: 26px;
            background-color: #fff;
            border-radius: 0 4px 4px 0;
        } 
    }
</style>


// WEBPACK FOOTER //
// src/components/datepicker/datepicker.vue